import React from "react";

/* The kit's pill, not the classroom app's own chip.
   cls-chip carried a coloured dot and read its tints off --good / --busy
   / --crit / --warn, four names this app invented beside the thirteen
   palette tokens the project actually has. pg-pill is what every other
   list and dialog in the project uses for the same job.

   The six statuses this app speaks map onto the kit's four tones. The
   mapping is here rather than at each call site so "absent" cannot read
   as "free" on one screen and not another. */
const TONE = {
  free: "pg-pill--good",
  occupied: "pg-pill--live",
  teaching: "pg-pill--live",
  maintenance: "pg-pill--bad",
  absent: "pg-pill--bad",
  shifted: "pg-pill--warn",
};

const StatusChip = ({ status, children }) => (
  <span className={`pg-pill ${TONE[status] || ""}`.trim()}>{children}</span>
);

export default StatusChip;
